import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Button, Input, Select } from 'antd';
import { IMaskInput } from "react-imask";

export interface MasterRateEditModalProps extends PopupProps {
    item: MasterMovieItemDto;
}

const MasterMovieEditModal = ({ isOpen, onClose, item }: MasterRateEditModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    

    /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();

   /* ======================================================
   * events
   * ====================================================== */
    const onCancel = () => {
        onClose?.(false);
    };
        
    const onSubmit = (e) => {
        onClose?.(true, {year_id: item.year_id, lecturer_srl: item.lecturer_srl, cnt: e.cnt, price: e.price, rate_price: e.rate_price});
      };
   
  /* ======================================================
   * effects
   * ====================================================== */

    useEffect(() => {
        form.setFieldsValue({
            cnt: item.cnt || 0,
            price: item.price || 0,
            rate_price: item.rate_price || 0,
        });
    }, []);

    return (
        <ModalWrapper open={isOpen} onCancel={onCancel} width={450} title={`[${item.year_id}] 영상매출수정`} closable>
            <Form
                form={form}
                name="saleRate"
                layout="horizontal"  
                labelCol={{ flex: '125px' }}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Form.Item label={'강사'}>
                    <label>{item.name}</label>   
                </Form.Item> 
                <Form.Item name="cnt" label={'비고(편수)'}>
                    <Input type={'number'} />
                </Form.Item>                  
                <Form.Item name="price" label={'내부영상제작매출'}>
                    <IMaskInput 
                        min={0} 
                        mask = {Number}
                        thousandsSeparator={','}
                        className={'ant-input'} 
                        unmask={'typed'} 
                        onAccept = {((value, mask) => form.setFieldValue('price', value))}/>                     
                </Form.Item>                              
                <Form.Item name="rate_price" label={'%반영'}>
                    <IMaskInput 
                        min={0} 
                        mask = {Number}
                        thousandsSeparator={','}
                        className={'ant-input'} 
                        unmask={'typed'} 
                        onAccept = {((value, mask) => form.setFieldValue('rate_price', value))}/>                      
                </Form.Item>                 
                <ButtonGroup className={'buttonsWrapper'}>
                    <Button onClick={onCancel}>취소</Button>
                    <Button htmlType="submit"  type="primary">{'저장'}</Button>
                </ButtonGroup>                
            </Form>
        </ModalWrapper>  
    )    
};

export default React.memo(MasterMovieEditModal);    